export const WALLET_TYPES = {
  METAMASK: 'METAMASK',
  OPERA: 'OPERA',
};
